import React, {useMemo} from 'react';
import {Table} from 'semantic-ui-react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {Filter, DefaultColumnFilter} from '../tableFilters';
import TablePagination from '../reactTablePagination';

const columnsTableWithProps = (columnsList) => {
  return columnsList;
};

const ReactTable = (props) => {
  const {list, columnsList} = props;
  const columnsTable = columnsTableWithProps(columnsList);
  const data = useMemo(() => list, []);
  const columns = useMemo(() => columnsTable, []);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    prepareRow,
    page,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    'state': {pageIndex, pageSize},
  } = useTable(
    {
      columns,
      data,
      'defaultColumn': {'Filter': DefaultColumnFilter},
      'initialState': {'pageIndex': 0, 'pageSize': 10},
      'autoResetFilters': false,
    },
    useFilters,
    usePagination,
    useRowSelect
  );

  return (
    <>
      <div className="table-container">
        <Table className="interactive" striped {...getTableProps()}>
          <Table.Header>
            {headerGroups.map((headerGroup) => (
              <Table.Row key="headers" {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`title-${index}`}
                    textAlign="center"
                    {...column.getHeaderProps()}
                  >
                    {column.render('Header')}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
            {headerGroups.map((headerGroup) => (
              <Table.Row key="filters" id="filters">
                {headerGroup.headers.map((column, index) => (
                  <Table.HeaderCell
                    key={`filter-${index}`}
                    className={index === 7 ? 'dropdown-header' : ''}
                    textAlign="center"
                  >
                    <Filter column={column} />
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            ))}
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            {!page.length && (
              <Table.Row>
                <Table.Cell colSpan={15} textAlign="center">
                  No hay datos disponibles
                </Table.Cell>
              </Table.Row>
            )}
            {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row key={i}>
                    {row.cells.map((cell) => {
                      return (
                        <Table.Cell textAlign="center" {...cell.getCellProps()}>
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
          </Table.Body>
        </Table>
      </div>
      <TablePagination
        data={data}
        canPreviousPage={canPreviousPage}
        pageIndex={pageIndex}
        pageOptions={pageOptions}
        pageSize={pageSize}
        canNextPage={canNextPage}
        nextPage={nextPage}
        gotoPage={gotoPage}
        previousPage={previousPage}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default ReactTable;
